import { computed } from "vue";
import { useStore } from "vuex";

export const useTwilio = () => {
  const { getters, dispatch } = useStore();

  const twilioAccessToken = computed(() => getters["auth/twilioAccessToken"]);

  const fetchTwilioToken = () => dispatch("auth/fetchTwilioAccessToken");

  return {
    twilioAccessToken,
    fetchTwilioToken,
  };
};
